import { fileToBase64 } from "@repo/shared/utils";
import { byte2Kb } from "@/lib/utils";
import { apiService } from "./apiService";

export const userImportService = {
  uploadFile: async (file: File, tenantId: string, objectName: string) => {
    const base64File = await fileToBase64(file);
    const { data: createdFile } = await apiService.v1.uploadCsvFile(tenantId, {
      base64File,
      name: file.name,
      type: file.type,
      extension: file.name.split(".").pop(),
      sizeKb: byte2Kb(file.size),
      objectName,
    });
    return createdFile;
  },

  getUserDuplicates: async ({
    fileId,
    tenantId,
    bindConfig,
  }: {
    fileId: string;
    tenantId: string;
    bindConfig: UserImportBindingConfig;
  }) => {
    const { data: userDuplicates } =
      await apiService.v1.checkForUserImportDuplicates(tenantId, {
        fileId,
        bindConfig,
      });
    return userDuplicates.duplicates;
  },

  getImportPreview: async ({
    fileId,
    tenantId,
    bindConfig,
  }: {
    fileId: string;
    tenantId: string;
    bindConfig: UserImportBindingConfig;
  }) => {
    const { data: previewUsersData } = await apiService.v1.importUsersFromFile(
      tenantId,
      { isPreview: true, fileId, bindConfig }
    );
    return previewUsersData;
  },

  import: async ({
    fileId,
    tenantId,
    bindConfig,
    overwriteDuplicates,
  }: {
    fileId: string;
    tenantId: string;
    bindConfig: UserImportBindingConfig;
    overwriteDuplicates?: string[];
  }) => {
    const { data: importResult } = await apiService.v1.importUsersFromFile(
      tenantId,
      { isPreview: false, fileId, bindConfig, overwriteDuplicates }
    );
    return importResult;
  },

  getEmptyConfig: () => {
    return {
      firstName: "",
      lastName: "",
      email: "",
      role: "",
      salutation: "",
      primaryAddress: {
        type: "",
        street: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      },
    } as UserImportBindingConfig;
  },
};

export type UserImportBindingConfig = {
  firstName: string;
  lastName: string;
  email: string;
  salutation: string;
  role: string;
  //   primaryPhone: {
  //     type: string;
  //     number: string;
  //   };
  primaryAddress: {
    type: string;
    street: string;
    street2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
  };
};
